import React, { useState, useEffect } from "react";
import axios from "axios";
import { withRouter } from "react-router-dom";
import { createUseStyles} from "react-jss";
import classNames from "classnames";
import SearchArrangemangContainer from "../../../layouts/ListContainer/SearchArrangemangContainer";
import functions from "../../../utils/Functions";
import { GetData } from "../../../utils/axios";
import * as _ from "lodash";

const NavbarSearchbar = ({ history, className }) => {
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const classes = useStyles();
  useEffect(() => {
    async function fetchData() {
      setIsSearching(true);

      await GetData("/arrangemangs/search", cancelToken, {
        size: 11,
        page: 1,
        searchvalue: searchValue,
      }).then((data) => {
        if (!data || !data.result || data.result.length === 0) {
          if (data && _.isEmpty(data.result)) {
            setSearchResult([{ id: 0, namn: "Inga träffar" }]);
            setIsSearching(false);
          }
        } else {
          let results = data.result.map((res) => ({
            id: res.arrangemang.id,
            namn: res.arrangemang.arrNr + ", " + res.arrangemang.namn,
            listType: res.listType,
            viewType: res.viewType,
            sortOrder: res.sortOrder,
          }));

          let sortNew = results.sort(function (a, b) {
            return a.sortOrder - b.sortOrder;
          });

          /*           var sortedArray = results.sort(function (a, b) {
            return (
              a?.arrangemang?.id.localeCompare(a?.arrangemang?.id) ||
              b.viewType - a.viewType
            );
          });
 */ //Sortera på viewType och börja med högsta värdet så viewType (Visa actions) hamnar sist

          var result = _.uniqBy(sortNew, "id");
          setSearchResult(result);
          setIsSearching(false);
        }
      });
    }

    if (!searchValue || searchValue.length < 3) {
      setSearchResult([]);
      if (isSearching) {
        setIsSearching(false);
      }
      return;
    }
    const cancelToken = axios.CancelToken.source();
    fetchData();
    return () => {
      cancelToken.cancel("Axios request cancelled");
      setIsSearching(false);
    };
  }, [searchValue]);

  const handleOpenResult = (value) => {
    setIsSearching(false);
    setSearchValue("");
    if (value?.id === 0) {
      return;
    }
    history.push({
      pathname:
        functions.getUrlFromView(value.viewType, value.listType) +
        "/" +
        value.id,
      state: { fromSearch: true },
    });
  };

  const showAllResult = () => {
    history.push({
      pathname: "/search/arrangemang",
      search: "?query=" + searchValue.toLowerCase() + "&page=1",
      state: {
        title: "Sökresultat för " + searchValue,
        disabled: true,
        searchValue,
      },
    });
    setIsSearching(false);
    setSearchValue("");
  };

  return (
    <div className={classNames(classes.searchbarContainer, className)}>
      <SearchArrangemangContainer
        placeHolder="Sök arrangemang (nr eller namn)"
        className={classes.searchBar}
        isSearching={isSearching}
        searchValue={searchValue}
        searchResult={searchResult}
        handleReset={() => {
          setSearchResult([]);
          setSearchValue("");
        }}
        handleSearchChange={(e) => setSearchValue(e.target.value)}
        handleClick={handleOpenResult}
        handleClosePopup={() => setSearchResult([])}
        customSearchItem={{
          className: classes.customSearchItem,
          from: "searchNavbar",
        }}
        customButton={{
          action: showAllResult,
          requirements: 10,
          label: "Visa alla sökresultat",
        }}
        dataCy="searchfield-nvb-input"
      />
    </div>
  );
};

const useStyles = createUseStyles ({
  searchbarContainer: {
    display: "flex",
  },
  searchBar: {
    marginBottom: "0px",
    width: "100%",
    maxWidth: "400px",
  },
  customSearchItem: {
    maxHeight: "190px !important",
    height: "unset !important",
  },
});

export default withRouter(NavbarSearchbar);
